<script>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import { ref, onMounted } from "vue";
import moment from "moment";
import DateRangePicker from "daterangepicker";
import { useEstimateStore } from "@/stores/estimateStore";

export default {
  data() {
    return {
      title: "Estimates",
      text: "HR",
      text1: "Estimates",

      // 🔹 holds the row we want to convert
      convertTarget: null,
    };
  },
  setup() {
    const dateRangeInput = ref(null);
    const estimateStore = useEstimateStore();

    function booking_range(start, end) {
      const from = start.format("YYYY-MM-DD");
      const to = end.format("YYYY-MM-DD");

      estimateStore.filters.from_date = from;
      estimateStore.filters.to_date = to;

      // fetch with new date range
      estimateStore.fetch({ page: 1 });

      return start.format("M/D/YYYY") + " - " + end.format("M/D/YYYY");
    }

    onMounted(() => {
      estimateStore.fetch();

      if (dateRangeInput.value) {
        const start = moment().subtract(6, "days");
        const end = moment();

        new DateRangePicker(
          dateRangeInput.value,
          {
            startDate: start,
            endDate: end,
            ranges: {
              Today: [moment(), moment()],
              Yesterday: [
                moment().subtract(1, "days"),
                moment().subtract(1, "days"),
              ],
              "Last 7 Days": [moment().subtract(6, "days"), moment()],
              "Last 30 Days": [moment().subtract(29, "days"), moment()],
              "This Month": [
                moment().startOf("month"),
                moment().endOf("month"),
              ],
              "Last Month": [
                moment().subtract(1, "month").startOf("month"),
                moment().subtract(1, "month").endOf("month"),
              ],
            },
          },
          booking_range
        );

        booking_range(start, end);
      }
    });

    return {
      dateRangeInput,
      estimateStore,
    };
  },
  methods: {
    toggleHeader() {
      document.getElementById("collapse-header").classList.toggle("active");
      document.body.classList.toggle("header-collapse");
    },
    setStatus(status) {
      this.estimateStore.filters.status = status;
      this.estimateStore.fetch({ page: 1 });
    },
    openCreate() {
      this.$refs.estimatesModal.openCreate();
    },
    handleEdit(row) {
      this.$refs.estimatesModal.openEdit(row);
    },
    handleDelete(row) {
      this.$refs.estimatesModal.openDelete(row);
    },

    // 🔹 called when user clicks "Convert" in the table
    handleConvert(row) {
      console.log("handleConvert", row);
      this.convertTarget = row || null;
      // the Bootstrap modal will be opened via data-bs-toggle / data-bs-target
    },

    handlePreview(row) {
      if (this.$refs.previewModal && this.$refs.previewModal.open) {
        this.$refs.previewModal.open(row);
      }
    },

    // 🔹 called when user confirms inside the modal
    async confirmConvert() {
      if (!this.convertTarget || !this.convertTarget.id) return;

      try {
        const invoice = await this.estimateStore.convertToInvoice(this.convertTarget.id);
        await this.estimateStore.fetch({ page: 1 });
        this.convertTarget = null;
        if (invoice?.id) {
          this.$router.push(`/sales/invoices/${invoice.id}`);
        }
      } catch (e) {
        console.error("Failed to convert estimate", e);
      }
    },

    async exportPdf() {
      try {
        const res = await this.estimateStore.exportPdf();
        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download =
          "estimates-" + new Date().toISOString().slice(0, 10) + ".pdf";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        console.error("Failed to export PDF", e);
      }
    },
    async exportExcel() {
      try {
        const res = await this.estimateStore.exportExcel();
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download =
          "estimates-" + new Date().toISOString().slice(0, 10) + ".xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        console.error("Failed to export Excel", e);
      }
    },
  },
};
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <div class="me-2 mb-2">
            <div class="dropdown" v-can="'Estimate.Export'">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="exportPdf"
                  >
                    <i class="ti ti-file-type-pdf me-1"></i>Export as PDF
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="exportExcel"
                  >
                    <i class="ti ti-file-type-xls me-1"></i>Export as Excel
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="mb-2">
            <a
              href="javascript:void(0);"
              class="btn btn-primary d-flex align-items-center"
              @click="openCreate"
              v-can="'Estimate.Create'"
            >
              <i class="ti ti-circle-plus me-2"></i>Add Estimates
            </a>
          </div>
          <div class="head-icons ms-2">
            <a
              href="javascript:void(0);"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Estimates List</h5>
          <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
          >
            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Select Status
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setStatus('accepted')"
                    >Accepted</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setStatus('sent')"
                    >Sent</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setStatus('expired')"
                    >Expired</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setStatus('declined')"
                    >Declined</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setStatus('')"
                    >All</a
                  >
                </li>
              </ul>
            </div>
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Sort By : Last 7 Days
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    >Recently Added</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    >Ascending</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    >Desending</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    >Last Month</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    >Last 7 Days</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <estimates-table
              :rows="estimateStore.items"
              :loading="estimateStore.loading"
              @edit="handleEdit"
              @delete="handleDelete"
              @preview="handlePreview"
              @convert="handleConvert"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 🔹 Convert Estimate → Invoice confirm modal -->
    <div class="modal fade" id="convert_estimate_modal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body text-center">
            <span
              class="avatar avatar-xl bg-transparent-primary text-primary mb-3"
            >
              <i class="ti ti-transfer-in fs-36"></i>
            </span>
            <h4 class="mb-1">Convert to Invoice</h4>
            <p class="mb-3">
              Are you sure you want to convert
              <strong>{{
                convertTarget?.estimate_no || "this estimate"
              }}</strong>
              for
              <strong>{{
                convertTarget?.client?.name || "this client"
              }}</strong>
              into an invoice?
            </p>
            <div class="d-flex justify-content-center">
              <button
                type="button"
                class="btn btn-light me-3"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                class="btn btn-primary"
                data-bs-dismiss="modal"
                @click="confirmConvert"
              >
                <span
                  v-if="estimateStore.loadingForConvert"
                  class="spinner-border spinner-border-sm me-1"
                ></span>
                Yes, Convert
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by
        <a href="javascript:void(0);" class="text-primary"
          >DoneQuick Technological World</a
        >
      </p>
    </div>
  </div>

  <estimates-modal ref="estimatesModal" />
  <estimate-preview-modal ref="previewModal" />
</template>


